export const FIND_MFILES_BY_FILTERS = "FIND_MFILES_BY_FILTERS";
export const SET_MFILES = "SET_MFILES";
export const DOWNLOAD_MFILE = "DOWNLOAD_MFILE";

export const findMFilesByFilters = filters => ({ type: FIND_MFILES_BY_FILTERS, filters });
export const setMFiles = mfiles => ({ type: SET_MFILES, mfiles });

export const downloadMfile = row => ({ type: DOWNLOAD_MFILE, file: row })